import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { IAssessment } from '../models/assessment';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class AssessmentService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

  getAssessments(buildingId: string, schoolYear: string): Observable<{has_error: boolean, message: string, data: IAssessment[]}> {
    const url = environment.apiBaseUrl + endpoints.assessments.replace(':buildingId', buildingId);

    const params = new HttpParams().set('school_year', schoolYear);
    
    return this.http.get<{has_error: boolean, message: string, data: IAssessment[]}>(url, { params }).pipe(
      catchError(this.errorService.handleError)
    );
  }

  sendAssessmentRequest(buildingId: string, assessTypeId: string, assessSubTypeId: string, data: {email: string, contact_id?: number}[]): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.sendAssessmentRequest.replace(':buildingId', buildingId).replace(':assessmentTypeId', assessTypeId).replace(':assessmentSubTypeId', assessSubTypeId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
      catchError(this.errorService.handleError)
    );
  }

  deleteAssess(assessId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.deleteAssess.replace(':assessId', assessId);
    return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  downloadSurvey(guid: string): Observable<Blob> {
    const url = environment.apiBaseUrl + endpoints.downloadSurvey.replace(':guid', guid);
    return this.http.get(url, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => this.errorService.handleError(error));
      })
    );
  }
}